import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-sitekey"]

import { WidgetInstance } from 'friendly-challenge';
import { onMounted, onUnmounted, Ref, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FriendlyCaptcha',
  props: {
    sitekey: null,
    classes: { default: '' }
  },
  emits: ['solve'],
  setup(__props: any, { emit }) {

const props = __props as { sitekey: string, classes: string }



const el: Ref<HTMLElement> = ref(null);
const widget: Ref<WidgetInstance> = ref();

const doneCallback = () => {
    emit('solve', true);
};

const errorCallback = () => {
    emit('solve', false);
};

onMounted(() => {
    if (el.value) {
        widget.value = new WidgetInstance(el.value, {
            startMode: 'focus',
            doneCallback,
            errorCallback
        });
    }
});

onUnmounted(() => {
    if (widget.value) {
        widget.value.destroy();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "el",
    ref: el,
    class: _normalizeClass(["frc-captcha", __props.classes]),
    "data-sitekey": __props.sitekey
  }, null, 10, _hoisted_1))
}
}

})